import React, { useState } from 'react'
import './ServicesForm1.css'
import { useAlert } from "react-alert";
// import {
//   Typography,
//   TextField,
//   Button,
//   Stepper,
//   Step,
//   StepLabel,
// } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import {
  useForm,
  Controller,
  FormProvider,
  useFormContext,
} from "react-hook-form";

import MultiStep from 'react-multistep'
import { Stepper } from 'react-form-stepper';
import PersonalInfo from './PersonalInfo';
import Servicesinfo from './Servicesinfo';
import Complete from './Complete';






function ServicesForm1() {


    

    const [firstname, setfirstname] = useState();
    const [lastname, setlastname] = useState();
    const [email, setemail] = useState();
    const [phone, setphone] = useState();
    const [services, setservices] = useState();
    const [soletrader, setsoletrader] = useState();
    const [privatedriver, setprivatedriver] = useState();
    const [deliverydriver, setdeliverydriver] = useState();
    const [cis, setcis] = useState();
    const [taxidriver, settaxidriver] = useState();
    const [onlineseller, setonlineseller] = useState();
    const [other, setother] = useState();
    const [propertyaccount, setpropertyaccount] = useState();
    const [companyname, setcompanyname] = useState();
    const [companynumber, setcompanynumber] = useState();
    const [paye, setpaye] = useState();
    const [message, setmessage] = useState();
    const [step, setstep] = useState(1);


    const alert = useAlert();
    const [loading, setloading] = useState(false);

   




    const formSubmitHondler = async (e) => {
         setloading(true)
        e.preventDefault();

        const res = await fetch('https://ajh-accountant.onrender.com/api/quote-forms',  {

            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data:{
                    firstname, lastname, email, phone, services, soletrader, privatedriver, 
                    deliverydriver, cis, taxidriver, onlineseller, other, propertyaccount, 
                    companyname, companynumber, paye, message
            }
            })
        }).then((response)=>{
            response.json()
setloading(false)
            alert.success("Form Submitted Successfully");

        }).catch((error)=>{
            setloading(true)
            alert.success('Error Occurs Please Try Again After Some Time' , error);
        })

        setstep(step + 1)

        // const data = await res.json()
        
        setfirstname('');
        setlastname('');
        setemail('');
        setphone('');
        setservices('');
        setsoletrader('');
        setprivatedriver('');
        setdeliverydriver('');
        setcis('');
        settaxidriver('');
        setonlineseller('');
        setother('');
        setpropertyaccount('');
        setcompanyname('');
        setcompanynumber('');
         setpaye('');
        setmessage('');

        // console.log(firstname, lastname, email, phone, services, soletrader, privatedriver, deliverydriver, cis, taxidriver, onlineseller, other, propertyaccount, companyname, companynumber, paye, message)

    }

    // const nextstep = () => {
    //     setstep(step + 1)
    // }


// const servicesfun = (e) => {
//     setservices(e.target.value)
//     setsoletrader('');
//     setprivatedriver('');
//     setdeliverydriver('');
//     setcis('');
//     settaxidriver('');
//     setonlineseller('');
//     setother('');
//     setpropertyaccount('');
//     setcompanyname('');
//     setcompanynumber('');
//     setpaye('');
// }




  return (
    <div>
          <div className="container-fluid contacts-div1">
              <svg
                  className="contact-vector1 d-sm-block d-none"
                  width="65"
                  height="201"
                  viewBox="0 0 65 201"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                  <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M103.476 0.0623773C144.217 1.51047 171.061 37.8544 183.39 76.877C195.394 114.872 192.755 158.559 161.184 182.719C127.602 208.417 81.0343 206.104 46.6254 181.535C11.0388 156.125 -9.07933 112.331 4.02486 70.5016C17.4843 27.5381 58.656 -1.53073 103.476 0.0623773Z"
                      fill="#FFB532"
                  />
              </svg>

              <div className="container service-main-contact-div2 bg-white">
                  <h1 className=" contactus-text1 ">
                      Get In Touch With <span>US</span>.
                  </h1>
                  <div className="contactus-btn-div">
                      <a href="tel:+44 01204 840303">
                          <div className="contact-btn1">
                              <p className="contactus-text2 text-center">+44 01204 840303</p>
                          </div>
                      </a>
                      <a href="mailto:info@ajhaccountant.co.uk">
                          <div className="contact-btn2">
                              <p className="contactus-text2">info@ajhaccountant.co.uk</p>
                          </div>
                      </a>
                  </div>

                  <div >
                      
{step === 1 ? 
                      <PersonalInfo
                          firstname={firstname}
                          setfirstname={setfirstname}
                          setlastname={setlastname}
                          lastname={lastname}
                          setemail={setemail}
                          email={email}
                          phone={phone}
                          setphone={setphone}
                          setstep={setstep}
                          step={step}

                          ></PersonalInfo> : step === 2 ? <Servicesinfo
                              services={services}
                               setservices={setservices} 
                               soletrader={soletrader}
                                setsoletrader={soletrader} 
                                privatedriver={privatedriver} 
                                setprivatedriver={setprivatedriver}
                                 deliverydriver={deliverydriver} 
                                 setdeliverydriver={setdeliverydriver}
                                 cis={cis} 
                                 setcis={setcis}
                                 taxidriver={taxidriver} 
                                 settaxidriver={settaxidriver} 
                                 onlineseller={onlineseller}
                                  setonlineseller={setonlineseller} 
                                  other={other}
                                  setother={setother}
                                  propertyaccount={propertyaccount}
                                   setpropertyaccount={setpropertyaccount} 
                                   companyname={companyname}
                          setcompanyname={setcompanyname} 
                          companynumber={companynumber} 
                          setcompanynumber={setcompanynumber} 
                          paye={paye} 
                          setpaye={setpaye} 
                          message={message} 
                          setmessage={setmessage}
                              formSubmitHondler={formSubmitHondler}
                              loading={loading}
                              step={step}
                              setstep={setstep}

                          ></Servicesinfo> : <Complete></Complete>
                      
}
                    

                  </div>
              </div>
          </div>
    </div>
  )
}

export default ServicesForm1
